'use strict';

const EMAIL_SIGNUP_STORAGE_KEY = 'email_signup_utag';
const SOCIAL_LOGIN_REFERRER_KEY = 'socialLoginReferrer';

function getCookieValue(cookieName) {
  if (typeof document === 'undefined' || !document.cookie) {
    return '';
  }

  return document.cookie.split('; ').reduce(function (value, cookieEntry) {
    if (value) {
      return value;
    }

    var parts = cookieEntry.split('=');
    if (parts[0] !== cookieName) {
      return '';
    }

    return decodeURIComponent(parts.slice(1).join('='));
  }, '');
}

function clearCookie(cookieName) {
  if (typeof document === 'undefined') {
    return;
  }

  document.cookie = cookieName + '=; Max-Age=0; path=/';
}

function restoreSocialLoginReferrer() {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return;
  }

  var preservedReferrer = '';

  try {
    preservedReferrer = getCookieValue(SOCIAL_LOGIN_REFERRER_KEY);
  } catch (e) {
    preservedReferrer = '';
  }

  // If the cookie key is not present at all, there is nothing to restore.
  if (document.cookie.indexOf(SOCIAL_LOGIN_REFERRER_KEY + '=') === -1) {
    return;
  }

  if (preservedReferrer === '__EMPTY_REFERRER__') {
    preservedReferrer = '';
  }

  try {
    Object.defineProperty(document, 'referrer', {
      configurable: true,
      get: function () {
        return preservedReferrer;
      }
    });
  } catch (e) {
    // Ignore browsers that do not allow redefining document.referrer.
  }

  clearCookie(SOCIAL_LOGIN_REFERRER_KEY);
}

function isCheckoutOrOrderConfirmationPage(data) {
  if (!data || !data.page_type) {
    return false;
  }

  const pageType = data.page_type.toLowerCase();

  if (pageType === 'checkout') {
    return true;
  }

  return pageType === 'confirmation' && data.rendered_page === 'orderconfirmation';
}

function mergeStoredEmailSignupTrackingIntoDataLayer(data, currentEventData) {
  if (!data || !isCheckoutOrOrderConfirmationPage(data)) {
    return data;
  }

  if (data.page_type.toLowerCase() === 'checkout' && (!currentEventData || currentEventData.email_signup !== true)) {
    delete data.email_signup;
    delete data.email_signup_location;
    try {
      window.sessionStorage.removeItem(EMAIL_SIGNUP_STORAGE_KEY);
    } catch (e) {
      // Ignore storage failures (private mode / blocked storage).
    }
    return data;
  }

  if (data.email_signup === true) {
    return data;
  }

  delete data.email_signup;
  delete data.email_signup_location;

  try {
    const rawValue = window.sessionStorage.getItem(EMAIL_SIGNUP_STORAGE_KEY);

    if (!rawValue) {
      return data;
    }

    const storedPayload = JSON.parse(rawValue);

    if (!storedPayload || storedPayload.email_signup !== true) {
      try {
        window.sessionStorage.removeItem(EMAIL_SIGNUP_STORAGE_KEY);
      } catch (e) {
        // Ignore storage failures (private mode / blocked storage).
      }
      return data;
    }

    data.email_signup = true;

    if (!data.email_signup_location && storedPayload.email_signup_location) {
      data.email_signup_location = storedPayload.email_signup_location;
    }
  } catch (e) {
    // Ignore storage failures (private mode / blocked storage).
  }

  return data;
}

const tealium = {
  eventCount: 0,

  updateData: function (arr) {
    window.utag_data = mergeStoredEmailSignupTrackingIntoDataLayer(window.utag_data || {}, arr);

    const { utag_data } = window;
    const { search_mode, search_engine, fbb_search_enabled } = utag_data || {};
    const updatedArr = { ...arr, search_mode, search_engine, fbb_search_enabled };
    if (window.utag_data_backup) {
      window.utag_data = window.utag_data_backup;
    }else{
      window.utag_data_backup = window.utag_data;
    }
    window.utag_data = mergeStoredEmailSignupTrackingIntoDataLayer(window.utag_data || {}, arr);
    window.utag_data = { ...window.utag_data, ...arr };
    return { updatedArr:updatedArr, isAdobeAnalytics:true };
  },

  triggerEvent: function (arr) {
    const { utag, adobeDataLayer } = window;
    const { updatedArr, isAdobeAnalytics } = this.updateData(arr);
    if(window.utag_data && window.utag_data.page_name && window.utag_data.page_name.toLowerCase() === 'confirmation' &&
                           window.utag_data.page_type && window.utag_data.page_type.toLowerCase() === 'confirmation' &&
                           window.utag_data.rendered_page && window.utag_data.rendered_page !== 'orderconfirmation') {
      window.utag_date.page_name = 'maybeorderdetails';
      window.utag_data.page_type = 'maybeorderdetails';
    }
    if (isAdobeAnalytics) {
      try {
        adobeDataLayer.push(window.utag_data);
      } catch (e) {
        console.log(e.message ?  e.message : e);
      }
    } else {
      utag.link(updatedArr);
    }
    if (isAdobeAnalytics) {
      console.log('Tealium event triggered', window.utag_data);
    }else {
      console.log('Tealium event triggered', updatedArr);
    }
    return updatedArr;
  },
  triggerViewEvent: function (arr) {
    const { utag, adobeDataLayer } = window;
    const { updatedArr, isAdobeAnalytics } = this.updateData(arr);
    if (isAdobeAnalytics) {
      try {
        adobeDataLayer.push(window.utag_data);
      } catch (e) {
        console.log(e.message ?  e.message : e);
      }
    }else{
      utag.view(updatedArr);
    }
    if (isAdobeAnalytics) {
      console.log('Tealium event triggered', window.utag_data);
    }else {
      console.log('Tealium event triggered', updatedArr);
    }
    return updatedArr;
  }
};

module.exports = tealium;

if (typeof window !== 'undefined') {
  restoreSocialLoginReferrer();
  window.utag_data = mergeStoredEmailSignupTrackingIntoDataLayer(window.utag_data || {});
}
